export default __webpack_public_path__ + "static/media/ગુજરાત સરકાર જીપીડીપી માર્ગદર્શિકા 30 ડિસેમ્બર 2015.77a7b89c.pdf";